import { render, staticRenderFns } from "./downActivityPopup.vue?vue&type=template&id=6f152327&scoped=true&"
import script from "./downActivityPopup.vue?vue&type=script&lang=js&"
export * from "./downActivityPopup.vue?vue&type=script&lang=js&"
import style0 from "./downActivityPopup.vue?vue&type=style&index=0&id=6f152327&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f152327",
  null
  
)

export default component.exports